import { AxiosError } from 'axios';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Options } from '@/components/mi-dialog/MiDialog';
import { Order } from '@/models/Order';
import ErrorHandler from '@/support/ErrorHandler';

@Component<EditPersonalNotesDialog>({})
export default class EditPersonalNotesDialog extends Vue {
  @Prop({})
  protected order !: Order;

  protected close() {
    this.$emit('close', false);
  }

  protected update() {
    this.$store.dispatch('openDialog', this.dialogOptions);
  }

  protected get dialogOptions(): Options {
    return {
      title: this.$t('dialogOptions.confirmation').toString(),
      text: this.$tc('orders.orderDetail.webshop.personalNote.sureYouWantToUpdate').toString(),
      type: 'warning',
      buttons: {
        confirm: {
          text: this.$t('dialogOptions.button.ok').toString(),
          action: () => {
            const payload = {
              intro: this.order.intro,
              outro: this.order.outro,
            }

            new Order()
              .updateOrder(this.order.id as string, payload)
              .then(() => {
                this.$emit('close');
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              })
          },
        },
        cancel: {
          text: this.$t('dialogOptions.button.cancel').toString(),
          action: () => {
            //
          },
        },
      },
    };
  }
}
